var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-chart',{ref:"chart",attrs:{"chart-type":"AreaChart","rows":_vm.computedRows,"columns":_vm.computedColumns,"options":_vm.options}})}
var staticRenderFns = []

export { render, staticRenderFns }